import React from 'react'
import Welcome from './client/Welcome'
import Confirm from './client/Confirm'
import Form from './client/Form'
import Verification from './client/Verification'
import Finish from './client/Finish'
import Login from './admin/Login'
import Panel from './admin/Panel'
import ProtectedRoute from './ProtectedRoute'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Access from './technicians/Access'
import TechPanel from './technicians/TechPanel'
import NewClient from './technicians/NewClient'
import ClientFinish from './technicians/ClientFinish'
import NewReport from './technicians/NewReport'
import ReportFinish from './technicians/ReportFinish'
import AdminRoute from './AdminRoute'

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Welcome />
        </Route>

        <Route exact path='/confirm'>
          <Confirm />
        </Route>

        <Route exact path='/form'>
          <Form />
        </Route>

        <Route exact path='/verification'>
          <Verification />
        </Route>

        <Route exact path='/finish'>
          <Finish />
        </Route>

        <Route exact path='/admin/login'>
          <Login />
        </Route>

        <Route exact path='/tecnico/login'>
          <Access />
        </Route>

        <AdminRoute
          exact
          path='/admin/panel'
          component={Panel}
          redirect='/admin/login'
        />

        <ProtectedRoute
          exact
          path='/tecnico/panel'
          component={TechPanel}
          redirect='/tecnico/login'
        />

        <ProtectedRoute
          exact
          path='/tecnico/crear-reporte'
          component={NewReport}
          redirect='/tecnico/login'
        />

        <ProtectedRoute
          exact
          path='/tecnico/crear-cliente'
          component={NewClient}
          redirect='/tecnico/login'
        />

        <ProtectedRoute
          exact
          path='/tecnico/cliente-final'
          component={ClientFinish}
          redirect='/tecnico/login'
        />
        <ProtectedRoute
          exact
          path='/tecnico/reporte-final'
          component={ReportFinish}
          redirect='/tecnico/login'
        />
      </Switch>
    </Router>
  )
}

export default App
